// extracted by mini-css-extract-plugin
export var avatarContainer = "_fb-0";
export var gray = "_fb-f";
export var green = "_fb-c";
export var icon = "_fb-9";
export var image = "_fb-1";
export var lg = "_fb-6";
export var md = "_fb-5";
export var presenceDot = "_fb-b";
export var red = "_fb-d";
export var sm = "_fb-4";
export var status = "_fb-a";
export var xl = "_fb-7";
export var xs = "_fb-3";
export var xxl = "_fb-8";
export var xxs = "_fb-2";
export var yellow = "_fb-e";